import { IEntityMetaData, IPropretyAttribute } from "../../_models/IEntityMetaData";
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { PropretyAttributes, NestedProperty, NavigationProperty } from "../../decorators/EntityDecorators";
import { Account } from "../matwins-manager/Account.model";
import { PointOfService } from "./PointOfService.model";
import { Room } from "./Room.model";
import { RoomReservationInst_Emp } from "./navigation-entities/RoomReservationInst_Emp.model";


export class RoomReservationInstance extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  startDate!: Date;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  endDate!: Date;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  iD_SP!: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_Account!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_POS!: number;

  description?: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_Room!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  timeZone!: number;

  @NestedProperty({ TargetType: Account })
  account?: Account;

  @NestedProperty({ TargetType: PointOfService })
  pointOfService?: PointOfService;

  @NestedProperty({ TargetType: Room })
  room?: Room;

  @NavigationProperty({ TargetType: RoomReservationInst_Emp })
  roomReservationInst_Emp?: RoomReservationInst_Emp[];

  GetType(): IEntityMetaData {
    return RoomReservationInstance.getMetaData();
  }
}
